import BaseBoosterBehavior, { IBaseBoosterBehaviorPlayMeta } from './BaseBoosterBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { BoosterType } from '../BoosterType';
import { TransactionType } from '../../../Utility/Tracking/DataSet/Transaction';
import { track } from '../../../Utility/Tracking/Track';
import { IGameState } from '../../Game/IGameState';

export default class PlusOneBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState, meta?: IBaseBoosterBehaviorPlayMeta): IGameState {
        let cardsState = {
            ...state.levelState.cardsState,
        };

        const targets: string[] = [];

        cardsState = CardStateHelper.addNewCards(cardsState, 1, targets);

        // Trigger plus cards animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.PLUS_ONE,
            cards: targets,
        });

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState: cardsState,
            },
        };

        return this.consumeItemOrCoins(state);
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        track('transactionType', TransactionType.INVENTORY);

        return {
            ...state,
            playerState: {
                ...state.playerState,
                inventory: {
                    ...state.playerState.inventory,
                    [BoosterType.PLUS_ONE]:
                        state.playerState.inventory[BoosterType.PLUS_ONE] - 1,
                },
            },
        };
    }

    public isPlayable(state: IGameState) {
        return this.getInventoryItem(state) > 0;
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory[BoosterType.PLUS_ONE];
    }
}
